import * as React from 'react';
import { useTranslation } from 'react-i18next';
import CRUDDataTable from 'dashboard/containers/CRUDDataTable';
import { getAllToursDashboard } from 'dashboard/_redux/actions/tours';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'dashboard/components/ui/Dialog';
import { Button } from 'dashboard/components/ui/Button';
import { useToursList } from './useToursList';
import './_ToursPage.scss';

const ToursPage: React.FC = () => {
  const {
    tours,
    loaded,
    dataTableRef,
    columns,
    isCreateModalOpen,
    formData,
    categories,
    loadingCategories,
    handleOpenCreateModal,
    handleCloseCreateModal,
    handleInputChange,
    handleSubmitCreate,
  } = useToursList();

  const [t] = useTranslation();

  return (
    <>
      <div className="tours-page">
        <div className="tours-card card card-body pt-10">
          <CRUDDataTable
            myRef={dataTableRef}
            loading={!loaded}
            data={tours}
            title={t('dashboard.tourPage.title') || 'Parcours (Tours)'}
            columns={columns}
            fetchDataFn={getAllToursDashboard}
            onAddButtonClick={handleOpenCreateModal}
          />
        </div>
      </div>

      {/*            <button type="submit" className="btn btn-primary">*/}
      {/*              {t('dashboard.tourPage.createButton') || 'Créer le parcours'}*/}
      {/*            </button>*/}
      {/*          </div>*/}
      {/*        </form>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>,*/}
      {/*  document.body*/}
      {/*)}*/}

      <Dialog
        open={isCreateModalOpen}
        onOpenChange={(open) => {
          if (!open) handleCloseCreateModal();
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{t('dashboard.tourPage.createTitle') || 'Créer un nouveau parcours'}</DialogTitle>
          </DialogHeader>

          <form onSubmit={handleSubmitCreate}>
            <div className="row">
              <div className="col-md-12 mb-3">
                <label htmlFor="name" className="form-label">
                  {t('dashboard.tourPage.name') || 'Nom du parcours'} * (FR)
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="col-md-12 mb-3">
                <label htmlFor="description" className="form-label">
                  {t('dashboard.tourPage.description') || 'Description'} * (FR)
                </label>
                <textarea
                  className="form-control"
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  rows={3}
                  required
                />
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="categoryTour" className="form-label">
                  {t('dashboard.tourPage.category') || 'Catégorie'}
                </label>
                <select
                  className="form-control"
                  id="categoryTour"
                  name="categoryTour"
                  value={formData.categoryTour}
                  onChange={handleInputChange}
                  required
                  disabled={loadingCategories}
                >
                  <option value="">
                    {loadingCategories ? 'Chargement...' : 'Sélectionnez une catégorie'}
                  </option>
                  {categories.map((category) => (
                    <option key={category._id} value={category._id}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <DialogFooter>
              <Button type="button" onClick={handleCloseCreateModal}>
                {t('dashboard.tourPage.cancelButton') || 'Annuler'}
              </Button>
              <Button type="submit">
                {t('dashboard.tourPage.createButton') || 'Créer le parcours'}
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ToursPage;
